import { useCallback, useState } from "react";

export const useOpen = (
  initialOpen = false
): [boolean, () => void, () => void] => {
  const [open, setOpen] = useState(initialOpen);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);
  return [open, openDialog, closeDialog];
};
